/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(SplitText, ScrollTrigger);
import imagesLoaded from 'imagesloaded';
// import { locoScroll } from "./modules/smooth-scrolling";
var viewportWidth = window.innerWidth || document.documentElement.clientWidth;

// Cursor stuff
// import Cursor from "./modules/cursor";
// import Magnetic from "./modules/magnetic";

import { parallax } from './modules/parallax';

// import './modules/smooth-scrolling';
imagesLoaded(document.querySelector('body'), function (instance) {
  document.querySelector('body').classList.remove('page-is-loading');
  parallax();
});

// Animate On Scroll
import { animateOnScroll } from './modules/animateOnScroll.js';
animateOnScroll();

// Don't load on mobile
function is_touch_enabled() {
  return ('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints > 0);
}

// Get URL Params
// import './modules/getUrlParams';

// Inline Video Controls
// import './modules/controlVideo';
import { controlVideo } from './modules/controlVideo';
var heroVideoExists = document.getElementById('homeHero__bRoll');
if (heroVideoExists) {
  controlVideo();
}

// Mobile vs. Desktop controls
if (!is_touch_enabled()) {
  // Set up cursor
  // const cursor = new Cursor();
  // $('[data-magnetic]').each(function () {new Magnetic(this);});
} else {
  $('body').addClass('touch');
}

// Load 'em
import { mobileNav } from './modules/mobileNav';
mobileNav();

import { stickyNav } from './modules/stickyNav';
stickyNav();

import { featuredSlider } from './modules/featuredSlider';
var featuredSliderExists = document.querySelector('.featured__slider');
if (featuredSliderExists) {
  imagesLoaded(document.querySelector('body'), function (instance) {
    featuredSlider();
  });
}

import { moreSlider } from './modules/moreSlider';
var moreSliderExists = document.querySelector('.moreSlider');
if (moreSliderExists) {
  moreSlider();
}

import { testimonialsSlider } from './modules/testimonialsSlider';
var testimonialsSliderExists = document.querySelector('.testimonials__slider');
if (testimonialsSliderExists) {
  testimonialsSlider();
}

import { featuredTipsSlider } from './modules/featuredTipsSlider';
var featuredTipsSliderExists = document.querySelector('.featuredTips__slider');
if (featuredTipsSliderExists) {
  imagesLoaded(document.querySelector('.featuredTips'), function (instance) {
    document.querySelector('body').classList.remove('page-is-loading');
  });
  featuredTipsSlider();
}

import { featuredRecipesSlider } from './modules/featuredRecipesSlider';
var featuredRecipesSliderExists = document.querySelector('.featuredRecipes__slider');
if (featuredRecipesSliderExists) {
  imagesLoaded(document.querySelector('.featuredRecipes'), function (instance) {
    document.querySelector('body').classList.remove('page-is-loading');
  });
  featuredRecipesSlider();
}

import { tipsSlider } from './modules/tipsSlider';
var tipsSliderExists = document.querySelector('.tipsSection__slider');
if (tipsSliderExists) {
  tipsSlider();
}

// On-Pack Landing Page Sliders
import { videoModuleSlider, stepsModuleSlider, cardsModuleSlider, recipesModuleSlider, mediaContentModuleSlider } from './modules/onPackSliders';
let videoModuleSliderExists = document.querySelector('.videoModule__slider');
let stepsModuleSliderExists = document.querySelector('.stepsModule__slider');
let cardsModuleSliderExists = document.querySelector('.cardsModule__slider');
let recipesModuleSliderExists = document.querySelector('.recipesModule__slider');
let mediaContentModuleSliderExists = document.querySelector('.mediaContentSliderModule__slider');

if (videoModuleSliderExists) {
  videoModuleSlider();
}

if (stepsModuleSliderExists) {
  stepsModuleSlider();
}

if (cardsModuleSliderExists) {
  cardsModuleSlider();
}

if (recipesModuleSliderExists) {
  recipesModuleSlider();
}

if (mediaContentModuleSliderExists) {
  mediaContentModuleSlider();
}

// Values Slider
import { valuesSlider } from './modules/valuesSliders'
let valuesSliderExists = document.querySelector('.values__slider')

if (valuesSliderExists) {
  valuesSlider()
}


import { popup, promoPopup } from './modules/popup';
var popupExists = document.querySelector('.popupLink');
var promoPopupExists = document.querySelector('.popupTab');
if (popupExists) {
  popup();
}
if (promoPopupExists) {
  promoPopup();
}

import { forms } from './modules/forms';
var formExists = document.querySelector('.form, .gform_body');
if (formExists) {
  forms();
}

// import { toggles } from './modules/toggle';
// toggles();

// import { anchorLinks } from './modules/anchors';
// anchorLinks();

// var bgText = $('.bgText').attr('data-section-target'); // storyIntro
// var bgTextTarget = $("[data-section-target='" + bgText + "']").offset().top;
// alert(bgTextTarget);

// bgText.offset({
//   top: bgTextTarget.top
// });

import { filter } from './modules/filter.js';
// import { stickyFilterOnMobile } from './modules/stickyFilterOnMobile.js';
var productFilterExist = document.querySelector('.filter');
if (productFilterExist) {
  filter();
}

// Share Recipe Toggle
import { shareRecipe } from './modules/shareRecipe.js';
var shareRecipeExists = document.querySelector('.shareRecipe');
if (shareRecipeExists) {
  shareRecipe();
}

// Init Fancy Titles
import { fancyTitles } from './modules/fancyTitles';
var fancyTitleExists = document.querySelector('.fancyTitle');
if (fancyTitleExists) {
  fancyTitles();
}


// FAQs
import { faqs, readmore } from './modules/faqs';
var faqsExists = document.querySelector('.faqs');
if (faqsExists) {
  faqs();
}
var readmoreExists = document.querySelector('.readmore');
if (readmoreExists) {
  readmore();
}

// Jobs
import { jobs } from './modules/jobs';
var jobsExists = document.querySelector('.hiring__toggle');
if (jobsExists) {
  jobs();
}

// Reviews
import { reviews } from './modules/reviews';
var reviewsExist = document.querySelector('.submitReview__button');
if (reviewsExist) {
  reviews();
}


// Refire stuff on window resize
var timeout = false, // holder for timeout id
  delay = 250; // delay after event is "complete" to run callback

// window.resize event listener
window.addEventListener('resize', function () {
  // clear the timeout
  clearTimeout(timeout);
  // start timing for event "completion"
  timeout = setTimeout(function () {
    fancyTitles();
    if (featuredSliderExists) {
      featuredSlider('resize');
    }
  }, delay);
});


if (window.innerWidth < 769) {
  $('.woocommerce-MyAccount-navigation ul').hide();
  $('.woocommerce-MyAccount-navigation').on('click tap', function () {
    $(this).find('ul').slideToggle();
  });
}

$('.siteHeader__search').on('click tap', function () {
  $('.searchContainer').addClass('open');
});

$('.searchContainer__close').on('click tap', function () {
  $('.searchContainer').removeClass('open');
});

$('.recipesFilter').on('click tap', function () {
  $(this).find('.alm-filter--inner ul').toggleClass('open');
});

$('.reviewAnchor').on('click tap', function(e) {
  e.preventDefault();
  $('html, body').animate({
    'scrollTop': $('.submitReview__button').offset().top - 40
  }, 300);
  $('.submitReview__button').trigger('click');
});




// Social Share Buttons
// $(".share-buttons").on("click", "li.facebook a", function (event) {
//   event.preventDefault();
//   var link = encodeString(window.location.href);
//   var title = $(this).parents(".how-to-section").find("h3").text();
//   var shareUrl = "https://www.facebook.com/sharer.php?u=" + link;
//   var shareTitle = "Share on Facebook";
//   popupCenter(shareUrl, shareTitle, 580, 470);
//   //window.open();
// });

// $(".share-buttons").on("click", "li.pinterest a", function (event) {
//   event.preventDefault();
//   var type = '';
//   if ($("body").hasClass('single-fricks_recipe')) {
//     type = 'recipe';
//   } else if ($("body").hasClass('single-fricks_how_to')) {
//     type = 'how-to';
//   } else {
//     type = 'unknown';
//   }
//   var title = '';
//   if (type == 'how-to') {
//     title = encodeString($(this).parents(".how-to-section").find("h3").text());
//   } else if (type == 'recipe') {
//     title = encodeString($(".recipe-header h1").text());
//   }
//   var link = encodeString(window.location.href);
//   var media = encodeString($(this).data("image"));
//   var shareUrl = "http://pinterest.com/pin/create/button/?url=" + link + "&description=" + title + "&media=" + media;
//   console.log(shareUrl);
//   var shareTitle = "Share on Pinterest";
//   popupCenter(shareUrl, shareTitle, 580, 470);
//   //window.open();
// });

// $(".share-buttons").on("click", "li.email a", function (event) {
//   event.preventDefault();
//   var link = '';
//   if ($(this).attr('href') == '#') {
//     link = window.location.href;
//   } else {
//     link = $(this).attr('href');
//   }
//   var type = '';
//   var typeIntro = '';
//   if ($("body").hasClass('single-fricks_recipe')) {
//     type = 'recipe';
//     typeIntro = 'I found this recipe online and thought you would like it:';
//   } else if ($("body").hasClass('single-fricks_how_to')) {
//     type = 'how-to';
//     typeIntro = 'I found this how to online and thought it might help you:';
//   } else if ($("body").hasClass('single-product')) {
//     type = 'product';
//     typeIntro = 'I found this product online and thought you might like it:';
//   } else {
//     type = 'unknown';
//     typeIntro = "I found this online and thought you would like it:";
//   }
//   var title = '';
//   var subject = '';
//   if (type == 'how-to') {
//     title = encodeString($(this).parents(".how-to-section").find("h3").text());
//     subject = title;
//   } else if (type == 'recipe') {
//     title = encodeString($(".recipe-header h1").text());
//     subject = title + " Recipe";
//   }
//   window.location.href = "mailto:?to=&subject=" + subject + "&body=" + typeIntro + "%0D%0A%0D%0A" + title + "%0D%0A" + link;
//   return false;
// });

// $(".share-buttons").on("click", "li.print a", function (event) {
//   if ($(this).attr('href') == '#') {
//     event.preventDefault();
//     window.print();
//   }
// });

$('.alm-filter--link.field-radio').on('click tap', function() {
  var selection = $(this).text();
  // alert(selection);
  $('.recipes__title').text(selection + " Recipes");
});

$('.alm-filters--reset-button').on('click tap', function() {
  // var selection = $(this).text();
  // alert(selection);
  $('.recipes__title').text("All Recipes");
});

// Added to cart
$('.ajax_add_to_cart').on('click tap', function() {
  $(this).text('Adding to Cart');
  setTimeout(() => {
    $(this).text('Added to Cart');
  }, 2000);
});

// Hide product toggles
$('.productToggle__toggle').hide();
$('.productToggle__title').on('click tap', function() {
  $(this).toggleClass('active');
  $(this).parent().find('.productToggle__toggle').slideToggle();
});

$('.productToggle__title').each(function(i) {
  if (i === 0) {
    $(this).toggleClass('active');
    $(this).parent().find('.productToggle__toggle').slideToggle();      
  }
})

// const productToggles = document.querySelectorAll('.productToggle')

// for (const [i, productToggle] of productToggles.entries()) {
//   const toggle = productToggle.querySelector('.productToggle__toggle')
//   const title = productToggle.querySelector('.productToggle__title')

//   if (i === 0) {
//     $('.productToggle__toggle').toggleClass('active');
//     $('.productToggle').find('.productToggle__toggle').slideToggle();
//   }
// }

$('.printScreen').on('click tap', function(e) {
  e.preventDefault();
  window.print();
});

$('#wpsl-search-input').attr('placeholder','Type a postcode or address...');

